var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeImpresso(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_132",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_230_3",
    "data-name": "Componente 230 \\u2013 3",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2024",
    "data-name": "Grupo 2024",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Elipse_132)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_132-2",
    "data-name": "Elipse 132",
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    transform: "translate(9 6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-print",
    "data-name": "Icon ionic-md-print",
    transform: "translate(5.885 6.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-print-2",
    "data-name": "Icon ionic-md-print",
    d: "M33.181,12.919H8.8a5.537,5.537,0,0,0-5.424,5.612v12.16h6.767v7.483h21.7V30.691h6.767V18.531A5.537,5.537,0,0,0,33.181,12.919ZM29.12,35.368H12.86V24.143H29.12ZM31.839,4.5h-21.7v7.015h21.7V4.5Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#005288"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeImpresso);
export default __webpack_public_path__ + "static/media/icone_impressão.164a6e2f031803c88abe77912df018f8.svg";
export { ForwardRef as ReactComponent };